<template>
	<div>
		<div class="goods-item" @click="onNavigateTo()">
			<img style="width:3.45rem;height:3.3rem" :src="row.pic_url" >
			<div class="goods-row">
				<div class="goods-title show-one-row">{{row.title}}</div>
				<div class="flex-start goods-taps">
					<div class="goods-taps" v-if="row.discount_tags.length>0" v-for="(item,index) in row.discount_tags" :key="index">
						{{item}}
					</div>
				</div>
				<div class="flex-between goods-price-info">
					<div class="flex-start goods-price-b">
						¥<div class="goods-price">{{row.price_range[0]}}</div>
					</div>
					<div class="goods-order-count">{{row.views_count+row.sold_show_count}}人付款</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs';
	export default {
		name: "GoodsItem",
		components: {},
		props: {
			row: {
				type: Object,
				default: {
				}
			},
		},

		data: function() {
			return {
				duration: 300
			};
		},

		methods: {
			onNavigateTo() {
				let url='pages/index/goods/GoodsDetail/GoodsDetail'
				uni.navigateTo({
					url: '/' + url+'?url=https://h5.ccago.cn/cca-h5/dist/goodsdetail?'+qs.stringify({id:this.row.id})
				})
			
			},
			onRbLink(item) { 
				rbLink({
					name: item.url.name.substring(0, 1).toUpperCase() + item.url.name.substring(1),
					query: item.url.query
				});
			}
		},

		filters: {}
	};
</script>

<style scoped>
	.goods-order-count{
		font-size: 0.2rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		margin-right: 0.4rem;
	}
	.goods-price{
		font-size: 0.36rem;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #FE4754;
	}
	.goods-price-b{
		font-size: 0.24rem;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: #FE4754;
	}
	.goods-taps{
		font-size: 0.24rem;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FE4754;
		margin-right: 0.08rem;
	}
	.goods-title{
		font-size: 0.3rem;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #333333; 
	}
	 .goods-row{
		 flex: 1;
		 padding: 0 0.1rem;
	 }

	.goods-item {
		width: 3.36rem;
		height: 5.1rem;
		background: #FFFFFF;
		border-radius: 0.16rem;
		border-radius: 0.16rem;
		margin-bottom: 0.2rem; 
		display: flex;
		flex-direction: column;
		overflow: hidden;
		padding:0.1rem;
	}

	

	.show-two-row {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
	.show-one-row {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
	}
	.flex-start{
		display: flex;
		align-items: center;
	}
	.flex-between{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
</style>



// WEBPACK FOOTER //
// GoodsItem.vue?37d341a6